// extracted by mini-css-extract-plugin
export default {"customWrapper":"style_customWrapper__my9+L","customEditor":"style_customEditor__2P3aD"};